import React, { useState, useEffect } from "react";
import axios from "axios"; 
import { Trash } from "react-feather";
import { ArrowUp, ArrowDown } from "react-feather";
import { BASE_URL } from "./Baseurl";
 import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const DummyInput = () => {
 
   const [visitorDetails, setVisitorDetails] = useState({
     name: "",
     email: "",
     phone: "",
     designation: "",
   });




   useEffect(() => {
    const fetchVisitorDetails = async () => {
      const visitorId = localStorage.getItem("visitor_id");
      if (!visitorId) {
        console.error("Visitor ID not found in localStorage.");
        return; // Stop if visitor ID is not found
      }
  
      try {
        const response = await axios.get(`${BASE_URL}fetchVisitorDetailsByUserId/${visitorId}`);
        if (response.data.success) {
          setVisitorDetails(response.data.visitor_details);
        } else {
          toast.error("Failed to fetch visitor details.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        console.error("Error fetching visitor details:", error);
        toast.error("An error occurred while fetching visitor details.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
  
    fetchVisitorDetails();
  }, []);



  return (
    <>
    

<div className="text-center">
    <h4 className="text-danger"><strong>*Required Fields*</strong></h4>
    <small>Note : <i>This fields are mendatory on form.</i></small>
</div>

    <div className="row g-2 text-start" >
        <div className="col-md-6">
            <label>Full Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control" value={visitorDetails.name || ""}
              placeholder="Full Name Here"  readOnly
            />
          </div>

           <div className="col-md-6">
            <label>Email Address <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control" value={visitorDetails.email || ""}
              placeholder="Email Address"   readOnly
            />
          </div>

           <div className="col-md-6">
            <label>Phone Number <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control" value={visitorDetails.phone || ""}
              placeholder="Phone Number"  readOnly
            />
          </div>

           <div className="col-md-6">
            <label>Designation <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control" value={visitorDetails.designation || ""}
              placeholder="Designation"   readOnly
            />
          </div>
    </div>


    
    </>
  );
};

export default DummyInput;
